// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .editor_data {\n  border: 1px solid #eee !important;\n  border-radius: 5px;\n  -webkit-transition: border-color 0.5s ease-out;\n  padding: 10px;\n  cursor: text;\n}\n", ""]);
// Exports
module.exports = exports;
